import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  NavItem,
  NavLink,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../actions';

import { userCan } from '../helpers/Auth';
import { addFlashMessage } from '../helpers/FlashMessages';

const AddMenu = ({ dispatch, toggleNavigation }) => {
  const intl = useIntl();

  if (!userCan('add_users')) {
    return null;
  }

  const afterCreateNewUser = (user) => {
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({
        defaultMessage: 'A new User has been created',
      }),
      button: {
        url: `/admin/users/${user.uuid}`,
        text: intl.formatMessage({
          defaultMessage: 'Open User',
        }),
      },
    });
  };

  const openAddUserModal = () => {
    dispatch(showModal('UserEditModal', {
      className: 'modal-edit-user',
      notificationCallback: afterCreateNewUser,
    }));
  };

  return (
    <NavItem className="nav-add-menu">
      <NavLink
        id="add-icon"
        tag="a"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          openAddUserModal();
          toggleNavigation();
        }}
      >
        <span className="nav-item-icon">
          <i className="far fa-user-plus" />
        </span>
        <span className="nav-item-title">
          {intl.formatMessage({
            defaultMessage: 'Invite user',
          })}
        </span>
      </NavLink>
    </NavItem>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

AddMenu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  toggleNavigation: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(AddMenu);
